// extracted by mini-css-extract-plugin
var _1 = "TextMultiValuedListItem-moduleTextMultiValuedListItem__EdyG9 MultiValuedListItem-moduleMultiValuedListItem__IhIDF";
var _2 = "TextMultiValuedListItem-modulelarge__LjtYb";
var _3 = "TextMultiValuedListItem-modulemedium__EyIkZ";
var _4 = "TextMultiValuedListItem-modulesingle__i4X6c MultiValuedListItem-modulesingle__iZ78T";
var _5 = "TextMultiValuedListItem-modulesmall__Exlj6";
var _6 = "TextMultiValuedListItem-moduletext__U13qN";
var _7 = "TextMultiValuedListItem-modulex-large__nPE2Y";
var _8 = "TextMultiValuedListItem-modulex-small__iEfRF";
export { _1 as "TextMultiValuedListItem", _2 as "large", _3 as "medium", _4 as "single", _5 as "small", _6 as "text", _7 as "x-large", _8 as "x-small" }
